const RaCheckboxGroupInput = (palette) => ({
  styleOverrides: {
    root: {
      width: 'auto',
      '& .RaCheckboxGroupInput-label': {
        position: 'relative',
        transform: 'none',
        lineHeight: '1.5',
        color: palette.dark.grey
      },
      '& .RaCheckboxGroupInput-label span': {
        color: palette.dark.grey,
        fontSize: '14px',
        display: 'inline-block',
        marginBottom: '3px'
      }
    }
  }
});

export default RaCheckboxGroupInput;
